import { Terminal } from '../types/ViewModel/Terminal';
import { Berth } from '../types/ViewModel/Berth';
import { Port } from '../types/ViewModel/Port';
import { BerthFactory } from './BerthFactory';
import { TerminalBM } from '../types/BusinessModel/TerminalBM';

export class TerminalFactory {
    private berthFactory = new BerthFactory();
    constructor() {}

    public newTerminal(terminal: TerminalBM | null, port: Port | null): Terminal | null {
        const berthArray: Berth[] = [];
        if (terminal && terminal.berthList && terminal.berthList.length > 0) {
            terminal.berthList.map((b) => {
                const newBerth = this.berthFactory.newBerth(b, null);
                berthArray.push(newBerth);
            });
            // berthArray = berthArray.sort(b => b.berthDisplayName);
        }
        if (terminal) {
            return new Terminal(
                terminal.terminalId,
                terminal.portId,
                port,
                terminal.terminalShortName,
                terminal.terminalLongName,
                terminal.isPriorityTerminal,
                terminal.terminalIdentity,
                terminal.changedBy,
                terminal.isDeleted,
                berthArray,
                null
            );
        }
        return null;
    }

    public newTerminalFromCode(terminal: Terminal | null, port: Port | null): Terminal | null {
        const berthArray: Berth[] = [];
        if (terminal && terminal.berthArray && terminal.berthArray.length > 0) {
            terminal.berthArray.map((b) => {
                const newBerth = this.berthFactory.newBerthFromCode(b, null);
                berthArray.push(newBerth);
            });
            // berthArray = berthArray.sort(b => b.berthDisplayName);
        }
        if (terminal) {
            return new Terminal(
                terminal.terminalId,
                terminal.portId,
                port,
                terminal.terminalShortName,
                terminal.terminalLongName,
                terminal.isPriorityTerminal,
                terminal.terminalIdentity,
                terminal.changedBy,
                terminal.isDeleted,
                berthArray,
                null
            );
        }
        return null;
    }

    private sortDate(a: Date, b: Date) {
        if (a > b) {
            return -1;
        }
        if (a < b) {
            return 1;
        }
        return 0;
    }

    public newEmptyTerminal() {
        return new Terminal(0, 0, null, null, null, false, null, null, false, null, null);
    }
}
